import { withFormsy } from 'formsy-react';
import React from 'react';
import PropTypes from 'prop-types';
import { Select, Async } from 'components/pure/form-fields/Select';
class SelectValidation extends React.Component {
  render() {
    const { setValue, getValue, name, options, isValid, isRequired, isPristine, disabled, multi, clearable, creatable, async: _async, handleOnChange, handleOnInputChange, required, resetValue, ...props } = this.props;
    const isInvalidClass = !isValid() && !isPristine() ? 'is-invalid form-control border-0 p-0' : 'form-control border-0 p-0';

    let onInputChange = handleOnInputChange;

    const handleChange = option => {
      multi ? setValue(option) : setValue(option ? option.value : '')
      handleOnChange && handleOnChange(option)
    }

    let Component = Select
    let componentPropTypes = Select.propTypes
    let componentOptions = _async ? { loadOptions: options } : { options }

    if (_async) {
      Component = Async
      componentPropTypes = { ...componentPropTypes, ...Async.propTypes }
    }

    const componentProps = {}

    for (let propKey in componentPropTypes) {
      if (props[propKey] !== undefined)
        componentProps[propKey] = props[propKey]
    }

    return <React.Fragment>
      <Component
        {...componentProps}
        {...componentOptions}
        {...props}
        creatable={creatable}
        name={name}
        className={isInvalidClass}
        value={getValue()}
        onChange={handleChange}
        disabled={disabled}
        isMulti={multi}
        clearable={clearable}
        onInputChange={onInputChange}
      />
      <span className="invalid-feedback">
        {isRequired() && (multi ? !getValue()?.length : !getValue()) && ' Field required'}
      </span>
    </React.Fragment>
  }
}

SelectValidation.propTypes = {
  setValue: PropTypes.func,
  getValue: PropTypes.func,
  name: PropTypes.string,
  options: PropTypes.array,
  isValid: PropTypes.func,
  isPristine: PropTypes.func,
  handleOnChange: PropTypes.func,
  handleOnInputChange: PropTypes.func,
  disabled: PropTypes.bool
};

SelectValidation.defaultProps = {
  disabled: false,
  creatable: false,
  async: false,
  multi: false
}

export default withFormsy(SelectValidation);
